import { render, staticRenderFns } from "./JapaneseMedical.vue?vue&type=template&id=1ad13eff&scoped=true&"
import script from "./JapaneseMedical.vue?vue&type=script&lang=js&"
export * from "./JapaneseMedical.vue?vue&type=script&lang=js&"
import style0 from "./JapaneseMedical.vue?vue&type=style&index=0&id=1ad13eff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad13eff",
  null
  
)

export default component.exports